import { createSlice } from '@reduxjs/toolkit';
import {
    fetchWorkingDay,
    createWorkingDay,
    updateWorkingDay,
    deleteWorkingDay,
    fetchWorkingDayStats,
} from '../thunks/workingDayThunks.js';

const initialState = {
    workingDay: [],
    loading: false,
    createLoading: false,
    stats: [],
    error: null,
};

const workingDaySlice = createSlice({
    name: 'workingDay',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchWorkingDay.fulfilled, (state, action) => {
                state.workingDay = action.payload;
                state.loading = false;
            })
            .addCase(createWorkingDay.pending, (state) => {
                state.createLoading = true;
                state.error = null;
            })
            .addCase(createWorkingDay.fulfilled, (state, action) => {
                state.stats = action.payload;
                state.createLoading = false;
            })
            .addCase(createWorkingDay.rejected, (state, action) => {
                state.error = action.error?.message || action.payload;
                state.createLoading = false;
            })
            .addCase(updateWorkingDay.pending, (state) => {
                state.createLoading = true;
                state.error = null;
            })
            .addCase(updateWorkingDay.fulfilled, (state) => {
                state.createLoading = false;
            })
            .addCase(updateWorkingDay.rejected, (state, action) => {
                state.createLoading = false;
                state.error = action.payload;
            })
            .addCase(deleteWorkingDay.pending, (state) => {
                state.createLoading = true;
                state.error = null;
            })
            .addCase(deleteWorkingDay.fulfilled, (state) => {
                state.createLoading = false;
            })
            .addCase(deleteWorkingDay.rejected, (state, action) => {
                state.createLoading = false;
                state.error = action.payload;
            })
            .addCase(fetchWorkingDayStats.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchWorkingDayStats.fulfilled, (state, action) => {
                state.stats = action.payload;
                state.loading = false;
            })
            .addCase(fetchWorkingDayStats.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error?.message;
            })
            .addMatcher(
                (action) => [fetchWorkingDay.rejected.type, fetchWorkingDayStats.rejected.type].includes(action.type),
                (state, action) => {
                    state.loading = false;
                    state.error = action.payload || action.error?.message;
                },
            )
            .addMatcher(
                (action) => [fetchWorkingDay.pending.type, fetchWorkingDayStats.pending.type].includes(action.type),
                (state) => {
                    state.loading = true;
                    state.error = null;
                },
            )
            .addDefaultCase((state) => state);
    },
});

export default workingDaySlice.reducer;
